import { useEffect, useState } from 'react'
import { Doughnut } from 'react-chartjs-2'
import WTypography from 'Components/whiteTypography'
import { Box, useMediaQuery, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

function Chart1({ tasks, handleMesTaches }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [chartDTasks, setChartDTasks] = useState({})
  const [revData, setRevData] = useState({
    labels: ['Non démarré', 'En cours', 'En retard', 'Terminées'],
    datasets: [
      {
        data: [80, 5, 15, 10],
        backgroundColor: ['#60829b', 'blue', 'red', 'green'],
        borderColor: ['#60829b', 'blue', 'red', 'green'],
        borderWidth: 1,
        hoverOffset: 4,
        precision: 0,
      },
    ],
  })

  const optiondonut = {
    responsive: true,
    aspectRatio: 1,
    maintainAspectRatio: false,

    onClick: function (evt, element) {
      if (element.length > 0) {
        let catName = revData.labels[element[0].index]
        // console.log(catName)
        if (catName === 'Terminées') {
          catName = 'Fait'
        }
        if (catName === 'En cours') {
          catName = 'En-Cours'
        }
        if (catName === 'Terminées') {
          catName = 'Fait'
        }
        if (catName === 'En retard') {
          catName = 'En-retard'
        }
        handleMesTaches('', catName)
      }
    },
    clip: true,
    cutout: '80%',
    plugins: {
      datalabels: {
        display: false,
      },

      legend: {
        display: false,
        events: [],
      },
    },
  }
  useEffect(() => {
    let remaingt = 0
    let non = 0
    let encours = 0
    let enretard = 0
    let terminees = 0
    tasks.forEach((v) => {
      if (v.Statut !== 'Fait') {
        remaingt++
      }
      if (v.Statut === 'Fait') {
        terminees++
      }
      if (v.Statut === 'En-Cours') {
        encours++
      }
      if (v.Statut === 'En-retard') {
        enretard++
      }
      if (v.Statut === 'Non démarré') {
        non++
      }
    })
    setChartDTasks({
      remaingt,
      non,
      encours,
      enretard,
      terminees,
    })
    setRevData({
      labels: ['Non démarré', 'En cours', 'En retard', 'Terminées'],
      datasets: [
        {
          data: [non, encours, enretard, terminees],
          backgroundColor: ['#60829b', 'blue', 'red', 'green'],
          borderColor: ['#60829b', 'blue', 'red', 'green'],
          borderWidth: 1,
          hoverOffset: 4,
          precision: 0,
        },
      ],
    })
  }, [tasks])

  const RevDoughnutChart = () => (
    <Box sx={{ margin: '10px', position: 'relative', width: '350px' }}>
      <Box height={210} position={'relative'} width={'100%'}>
        <Doughnut data={revData} options={optiondonut} />
      </Box>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          bottom: '50%',
          left: '50%',
          right: '50%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          ':hover': {
            cursor: 'pointer',
          },
        }}
      >
        <WTypography sx={{ color: 'white', whiteSpace: 'nowrap' }} variant="h3" align="center">
          {chartDTasks.remaingt}
        </WTypography>
        <WTypography sx={{ color: 'white', whiteSpace: 'nowrap' }} variant="h7" align="center">
          {t('mesToDo.remainingTasks')}
        </WTypography>
      </Box>
    </Box>
  )

  return (
    <Box display={'flex'} justifyContent={'center'} flexDirection={'column'} alignItems={'center'}>
      <RevDoughnutChart sx={{ margin: '10px' }} />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          marginTop: '20px',
          width: '350px',
        }}
      >
        <Box
          sx={{
            width: '50%',
            display: 'flex',
            alignItems: 'center',
            padding: '2px',
            ':hover': { cursor: 'pointer' },
          }}
          onClick={() => handleMesTaches('', 'Non démarré')}
        >
          <Box
            sx={{ width: '10px', height: '10px', background: '#60829b', marginRight: '8px' }}
          ></Box>

          <WTypography variant="h7" align="center">
            {t('mesToDo.statusNotStartedAlt')}
          </WTypography>
          <WTypography sx={{ marginLeft: 'auto', color: 'white' }} variant="h7" align="center">
            {chartDTasks.non}
          </WTypography>
        </Box>

        <Box
          sx={{
            width: '50%',
            display: 'flex',
            alignItems: 'center',
            padding: '2px',
            ':hover': { cursor: 'pointer' },
          }}
          onClick={() => handleMesTaches('', 'En-Cours')}
        >
          <Box sx={{ width: '10px', height: '10px', background: 'blue', marginRight: '8px' }}></Box>

          <WTypography variant="h7" align="center">
            {t('mesToDo.statusInProgressAlt')}
          </WTypography>
          <WTypography sx={{ marginLeft: 'auto', color: 'white' }} variant="h7" align="center">
            {chartDTasks.encours}
          </WTypography>
        </Box>

        <Box
          sx={{
            width: '50%',
            display: 'flex',
            alignItems: 'center',
            padding: '2px',
            ':hover': { cursor: 'pointer' },
          }}
          onClick={() => handleMesTaches('', 'En-retard')}
        >
          <Box sx={{ width: '10px', height: '10px', background: 'red', marginRight: '8px' }}></Box>

          <WTypography variant="h7" align="center">
            {t('mesToDo.statusLateAlt')}
          </WTypography>
          <WTypography sx={{ marginLeft: 'auto', color: 'white' }} variant="h7" align="center">
            {chartDTasks.enretard}
          </WTypography>
        </Box>

        <Box
          sx={{
            width: '50%',
            display: 'flex',
            alignItems: 'center',
            padding: '2px',
            ':hover': { cursor: 'pointer' },
          }}
          onClick={() => handleMesTaches('', 'Fait')}
        >
          <Box
            sx={{ width: '10px', height: '10px', background: 'green', marginRight: '8px' }}
          ></Box>

          <WTypography variant="h7" align="center">
            {t('mesToDo.statusCompletedAlt')}
          </WTypography>
          <WTypography sx={{ marginLeft: 'auto', color: 'white' }} variant="h7" align="center">
            {chartDTasks.terminees}
          </WTypography>
        </Box>
      </Box>
    </Box>
  )
}

export default Chart1
